import React from "react";

const Returns = () => {
  return (
    <div>
        <li className="content-body">
          We have a 30-day return policy on apparel, which means you have 30 days after receiving your item to request a return.
          <br/><br/>To start a return, you <i>must</i> contact us at <a className="cult-link" href="mailto:info@cultofneon.art" target="blank">info@cultofneon.art</a> and we'll coordinate with you on shipping needs & where to send. 
          <br/><br/>To be eligible for a return, your item must be in the same condition that you received it, unused or unworn - with tags, and in its original packaging.
          <br/><br/>If your return is accepted, we’ll send you instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted. Please note that if your country of residence is not United States, shipping your goods may take longer than expected.
          <br/><br/>You can always contact us for any questions at <a className="cult-link" href="mailto:info@cultofneon.art" target="blank">info@cultofneon.art</a>.
        </li>
        <br/>
        <br/>
        <li className="content-header">Damages and Issues</li>
        <li className="content-body">
          Please inspect your order upon receipt and contact us immediately if the item is damaged or if you receive the wrong item so that we may evaluate the issue and make it right.
          Certain types of items cannot be returned, like perishable goods (such as food, flowers, or plants) or custom products. We also do not accept returns for hazardous materials, flammable liquids, or gases. Please get in touch if you have questions or concerns about a specific item.
          <br/><br/>
          Unfortunately, we cannot accept returns on sale items.
        </li>
        <br/>
        <br/>
        <li className="content-header">Exchanges</li>
        <li className="content-body">
          The fastest way to ensure you get what you want is to return the item you have, and once the return is accepted, make a separate purchase for the new item.
          <br/><br/>
          European Union 3 day cooling off period
          Notwithstanding the above, if merchandise is being shipped into the European Union, you have the right to cancel or return your order within 3 days for any reason and without justification. As above, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase.
        </li>
        <br/><br/>
        <li className="content-header">Refunds</li>
        <li className="content-body">
          We will notify you once we’ve received and inspected your return to let you know if the refund was approved or not. If approved, you’ll be automatically refunded on your original payment method within 10 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too.

          If more than 15 business days have passed since we’ve approved your return, please contact us at <a className="cult-link" href="mailto:info@cultofneon.art" target="blank">info@cultofneon.art</a>.
        </li>
        <br/>
    </div>
  );
};

export default Returns;